import { reactive } from 'vue'

// Счетчик дел менеджера для бейджа «Сегодня» в меню; обновляет страница журнала дня.
export default reactive({
  actionCount: 0
})
